/* @ngInject */
export default function PromoSpaceApiService($resource, __env) {
    return {
        getPromosBySize: function (size, callback) {
            // DO NOT CHANGE url to Kemet api url. Asset is not part of api.
            $resource(
                `${__env.intellidataApiUrl}asset/image-promos`,
                {size: size}
            ).query(callback);
        }
    };
}
